import { QueryRefetchInterval } from '@cast/shared-types';
import { SecurityInsightsAgentStatus } from '@cast/types';

import { useSecurityInsightsAgentQuery } from 'hooks/queries/security-insights/useSecurityInsightsAgentQuery';

export const useIsClusterSecurityAgentInstalled = ({
  clusterId,
  enabled,
  refetchInterval,
}: {
  clusterId: string;
  enabled?: boolean;
  refetchInterval?: QueryRefetchInterval<SecurityInsightsAgentStatus>;
}) => {
  const { agent, isLoading, error, refetch } = useSecurityInsightsAgentQuery({
    clusterId,
    enabled,
    refetchInterval,
  });
  return { isInstalled: !!agent?.installed, isLoading, error, refetch };
};
